import { gql } from '@apollo/client';
import ErrorResultFragment from "../../../fragments/ErrorResult";

const INIT_COMPANY_TEMPLATE_UPLOAD = gql`
  mutation InitCompanyTemplateUpload($targetCompanyId: Int!) {
    companyAdminContext {
      companyTemplates {
        initCompanyTemplateUpload(targetCompanyId: $targetCompanyId) {
          success
          url
          errorResult {
            ...ErrorResultFields
          }
        }
      }
    }
  }
  ${ErrorResultFragment}
`;

export default INIT_COMPANY_TEMPLATE_UPLOAD;
